import { useState, useEffect } from 'react';
import Page from '../components/Page';
import contact596x920 from '../static/images/Contact.webp';
import plattegrond from '../static/pdf/DS_-_PLATTEGROND_2_798.pdf';


const Contact = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');


  useEffect(() => {
    fetch('./content/contact-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/contact-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>


  document.title = 'Contact - De School Amsterdam';
  const headerTitle = 'Contact';
  const description = 'Contact Contact Contact Contact Contact Contact';
  const extraTitleOne = 'Route';
  const extraTitleOneLink = plattegrond;
  const image = contact596x920;


  return <Page
          headerTitle={headerTitle}
          description={description}
          extraTitleOne={extraTitleOne}
          extraTitleOneLink={extraTitleOneLink}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default Contact;
